import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';

export const Section = styled(UI.Section)`
  position: relative;

  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  background-color: ${({ backgroundColor }) => backgroundColor};
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: row;
    height: ${({ height }) => (height ? `${height}vh` : '90vh')};
    flex-direction: ${({ reversed }) => (reversed ? 'row-reverse' : 'row')};
  }

  @media (min-width: 1280px) and (min-height: 1300px) {
    height: 1235px;
  }

  @media (min-width: 1920px) and (max-height: 899px) {
    min-height: 600px;
  }
  @media (min-width: 1280px) and (max-height: 699px) {
    min-height: 500px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  @media (min-width: 1024px) {
    height: auto;
    width: 50%;
  }
`;

export const ImgWrapper = styled.div`
  width: 100%;
  height: 100vw;
  overflow: hidden;
  @media (min-width: 1024px) {
    height: auto;
    width: 50%;
  }
`;

export const VideoWrapper = styled.div`
  position: relative;

  height: 60vw;
  width: 100%;
  overflow: hidden;
  min-height: 300px;
  overflow: hidden;

  @media (min-width: 1024px) {
    transition: width 0.3s ease, flex-shrink 0.3s ease;
    height: auto;
    width: 50%;
    flex-shrink: ${({ active }) => (active ? '0' : null)};
    width: ${({ active }) => (active ? '100%' : '50%')};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;

  transition: transform 0.2s ease;
  width: 100%;
  overflow: hidden;
  @media (min-width: 1024px) {
    text-align: ${({ textHorizAlign }) => textHorizAlign};
    flex-direction: column;
    justify-content: ${({ textAlign }) => textAlign};
    height: auto;
    width: 50%;
    transform: ${({ hidden, reversed }) => {
    if (!hidden) return 'none';
    reversed ? 'translateX(100%)' : 'translateX(-100%)';
  }};
  }
`;

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;

  width: 75px;
  height: 75px;
  padding: 0;
  padding: 0;

  background-color: transparent;
  background-image: url(${require('sources/playIcon.png')});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: none;
  outline: none;
  transform: translate(-50%, -50%);
  cursor: pointer;
  visibility: ${({ active }) => (active ? 'hidden' : 'visible')}
  transition: opacity 0.2s ease;

  @media (min-width: 1024px) {
    width: 200px;
    height: 200px;

    background-image: url(${require('sources/playIcon.png')});
  }
`;

export const Img = styled.img`
  display: block;
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: 50% 50%;
`;

export const TextContainer = styled(UI.HalfContainerNarrow)``;



// WEBPACK FOOTER //
// ./src/components/modules/TextMediaSection/styled.js